import { stringToNumber } from 'annotation-tools/utils';
import {
  updateCompanyId,
  updateImageId,
  updateKoumutenId,
  updateModelId,
  updateProjectId
} from '../global-state/router-id';
import { pathnameElements } from './routes';

export const updateIdWithPathlist = (pathlist: string[]) => {
  const [p0, p1, p2, p3, p4, p5, p6, p7] = pathlist;
  if (p0 === pathnameElements.koumutens) {
    const koumutenIdOrNull = stringToNumber(p1);
    updateKoumutenId(koumutenIdOrNull);

    if (p2 === pathnameElements.companies) {
      const companyIdOrNull = stringToNumber(p3);
      updateCompanyId(companyIdOrNull);

      if (p4 === pathnameElements.models) {
        const modelIdOrNull = stringToNumber(p5);
        updateModelId(modelIdOrNull);

        if (p6 === pathnameElements.images) {
          const imageIdOrNull = stringToNumber(p7);
          updateImageId(imageIdOrNull);
        }
      }

      if (p4 === pathnameElements.projects) {
        const projectIdOrNull = stringToNumber(p5);
        updateProjectId(projectIdOrNull);

        if (p6 === pathnameElements.images) {
          const imageIdOrNull = stringToNumber(p7);
          updateImageId(imageIdOrNull);
        }
      }
    }
  }
};
